import { Tooltip, Position } from "evergreen-ui"
import Figure from "./figure"

export default class Tuning1 extends Component {
  render() {
    const neurons = [379, 406, 385, 343, 342, 388, 340, 330, 349]

    const neuronImage = (layer, neuron) =>
      `https://storage.googleapis.com/fls/nickc/neuron_renders/${layer}_${neuron}.jpg`

    const colors = [
      `rgb(183,89,81)`,
      `rgb(193,159,91)`,
      `rgb(170,198,94)`,
      `rgb(131,199,100)`,
      `rgb(123,197,157)`,
      `rgb(90,148,194)`,
      `rgb(32,58,188)`,
      `rgb(129,72,190)`,
      `rgb(175,73,143)`,
    ]

    const ZoomedImg = ({ src, size, padding, ...props }) => (
      <Surface
        width={size}
        height={size}
        overflow="hidden"
        position="relative"
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{ position: "absolute", left: -padding, top: -padding }}
        />
      </Surface>
    )
    const neuronSize = 67
    const border = 3

    const Header = ({ children }) => (
      <Surface borderBottom marginBottom={20}>
        <Text size={600} marginBottom={5}>
          {children}
        </Text>
      </Surface>
    )

    return (
      <Surface gridColumn="screen" alignItems="center">
        <Surface
          width={850}
          marginY={40}
          alignSelf="center"
          flexFlow="row"
          justifyContent="space-between"
        >
          <Surface>
            <Header>Neuron Responses to Rotated Dataset Examples</Header>
            <Surface flexFlow="row">
              <Surface marginTop={10} marginRight={10}>
                {neurons.map((neuron, index) => (
                  <Tooltip
                    content={`mixed3b:${neuron}`}
                    position={Position.LEFT}
                  >
                    <Surface
                      overflow="hidden"
                      style={{ border: `${border}px solid ${colors[index]}` }}
                      borderRadius={5}
                      width={neuronSize}
                      height={neuronSize}
                      marginY={3}
                    >
                      <ZoomedImg
                        size={neuronSize}
                        padding={8}
                        src={neuronImage("mixed3b", neuron)}
                      />
                    </Surface>
                  </Tooltip>
                ))}
              </Surface>

              <img
                width={400}
                src={require("./images/tuning1-transparent.png")}
              />
            </Surface>
          </Surface>

          <Surface width={330} marginTop={60}>
            <Text opacity={0.9}>
              We collect dataset examples that maximally activate a single curve
              neuron. We rotate them by increments of 1 degree from 0 to 360
              degrees and record activations for all curve neurons.
            </Text>
            <Text marginTop={20} opacity={0.9}>
              The activations are shifted so that the points where each neuron
              responds are aligned. The curves are then averaged to create a
              typical response curve.
            </Text>
            <img
              width={300}
              style={{ alignSelf: "center", marginTop: 20 }}
              src={require("./images/tuning-methodology.png")}
            />
          </Surface>
        </Surface>
      </Surface>
    )
  }
}
